import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { 
  migrateRatingsToNumbers, 
  fixNullRatings,
  migrateEmptyPhotoURLs,
  fixRatingInconsistencies
} from '../../services/databaseService';
import { Spinner } from '../../components/Spinner/Spinner';
import './Maintenance.css';

function Maintenance() {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState('');

  // List of admin UIDs that are allowed to access this page
  const ADMIN_UIDS = ['hVJPhDmhNme7YycaHNOef0pnDHx1']; // Add your UID here

  const handleMigrateRatings = async () => {
    if (!window.confirm('Are you sure you want to migrate all ratings to numbers?')) {
      return;
    }

    setIsLoading(true);
    setStatus('Migration in progress...');

    try {
      await migrateRatingsToNumbers();
      setStatus('Migration completed successfully!');
    } catch (error) {
      console.error('Migration failed:', error);
      setStatus('Migration failed: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFixNullRatings = async () => {
    if (!window.confirm('Are you sure you want to fix all null/NaN ratings?')) {
      return;
    }

    setIsLoading(true);
    setStatus('Fixing null ratings...');

    try {
      const fixedCount = await fixNullRatings();
      setStatus(`Successfully fixed ${fixedCount} shows with null/NaN ratings!`);
    } catch (error) {
      console.error('Fix failed:', error);
      setStatus('Fix failed: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFixRatingInconsistencies = async () => {
    if (!window.confirm('Are you sure you want to fix rating inconsistencies? This will recalculate all show ratings.')) {
      return;
    }

    setIsLoading(true);
    setStatus('Fixing rating inconsistencies...');

    try {
      const fixedCount = await fixRatingInconsistencies();
      setStatus(`Successfully fixed ${fixedCount} shows with inconsistent ratings!`);
    } catch (error) {
      console.error('Fix failed:', error);
      setStatus('Fix failed: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMigratePhotoURLs = async () => {
    if (!window.confirm('Are you sure you want to update all empty profile photos with generated avatars?')) {
      return;
    }

    setIsLoading(true);
    setStatus('Updating empty profile photos...');

    try {
      const updatedCount = await migrateEmptyPhotoURLs();
      setStatus(`Successfully updated ${updatedCount} users with generated avatars!`);
    } catch (error) {
      console.error('Update failed:', error);
      setStatus('Update failed: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  if (!user || !ADMIN_UIDS.includes(user.uid)) {
    return <div className="maintenance-container">Not authorized</div>;
  }

  return (
    <div className="maintenance-container">
      <h1>Maintenance</h1>
      
      <div className="maintenance-section">
        <h2>Database Migrations</h2>
        <button 
          onClick={handleMigrateRatings}
          disabled={isLoading}
          className="maintenance-button"
        >
          Migrate Ratings to Numbers
        </button>

        <button 
          onClick={handleFixNullRatings}
          disabled={isLoading}
          className="maintenance-button"
          style={{ marginLeft: '10px' }}
        >
          Fix Null Ratings
        </button>

        <button 
          onClick={handleFixRatingInconsistencies}
          disabled={isLoading}
          className="maintenance-button"
          style={{ marginLeft: '10px' }}
        >
          Fix Rating Inconsistencies
        </button>

        <button 
          onClick={handleMigratePhotoURLs}
          disabled={isLoading}
          className="maintenance-button"
          style={{ marginLeft: '10px' }}
        >
          Update Empty Profile Photos
        </button>
      </div>

      {isLoading && <Spinner />}
      
      {status && (
        <div className={`status-message ${status.includes('failed') ? 'error' : 'success'}`}>
          {status}
        </div>
      )}
    </div>
  );
}

export default Maintenance; 